import Swal from "sweetalert2";
import { urlsPages } from "../../../../common/urls/urls-pages";
import { LoginRepository } from "../../infra/repository/login.repository";
import { LoginModel } from "../domain/login";

export class LoginUseCase {
    static async login(
        login: LoginModel,
    ) {
        try {
            const responseLogin = await LoginRepository.login(login);
            if (!responseLogin.authorized) {
                this.showError()
                return;
            }
            window.localStorage.setItem("signed", "true");
            window.location.href = urlsPages.drills;
        } catch (error) {
            this.showError();
        }
    }

    private static async saveToken(token: string) {
        window.localStorage.setItem("token", token);
    }

    private static async showError(error?: string) {
        Swal.fire({
            title: 'Error!',
            text: error || "Usuário ou senha inválidos",
            icon: 'error',
            confirmButtonText: 'Ok'
        })
    }
}
